import { paths, routes } from "config/paths";
import { useRouter } from "next/router";
import { useMemo } from "react";

import {
	SideNav,
	SideNavProps,
} from "~ui-components/components/molecules/side-nav";

export function LayerSettingsSideNav() {
	const router = useRouter();

	const navItems = useMemo<SideNavProps["navItems"]>(() => {
		const accountName = router.query["account-name"] as string;
		const mapId = router.query["map-id"] as string;
		const mapName = router.query["map-name"] as string;
		const layerId = router.query["layer-id"] as string;

		return [
			{
				items: [
					{
						title: "Layer details",
						href: paths.accountName.maps.mapId.mapName.layers.layerId.details(
							accountName,
							mapId,
							mapName,
							layerId,
						),
						matcher: {
							type: "equals",
							href: routes.accountName.maps.mapId.mapName.layers.layerId
								.details,
						},
					},
					{
						title: "Layer style",
						href: paths.accountName.maps.mapId.mapName.layers.layerId.style(
							accountName,
							mapId,
							mapName,
							layerId,
						),
						matcher: {
							type: "equals",
							href: routes.accountName.maps.mapId.mapName.layers.layerId.style,
						},
					},
					{
						title: "Label",
						href: paths.accountName.maps.mapId.mapName.layers.layerId.label(
							accountName,
							mapId,
							mapName,
							layerId,
						),
						matcher: {
							type: "equals",
							href: routes.accountName.maps.mapId.mapName.layers.layerId.label,
						},
					},
					{
						title: "Popup",
						href: paths.accountName.maps.mapId.mapName.layers.layerId.popup(
							accountName,
							mapId,
							mapName,
							layerId,
						),
						matcher: {
							type: "equals",
							href: routes.accountName.maps.mapId.mapName.layers.layerId.popup,
						},
					},
					{
						title: "Attribute format",
						href: paths.accountName.maps.mapId.mapName.layers.layerId.attributeFormatting(
							accountName,
							mapId,
							mapName,
							layerId,
						),
						matcher: {
							type: "equals",
							href: routes.accountName.maps.mapId.mapName.layers.layerId
								.attributeFormatting,
						},
					},
				],
			},
		];
	}, [router.query]);

	return <SideNav navItems={navItems} />;
}
